var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalSites(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H32C38.6274 0 44 5.37258 44 12V32C44 38.6274 38.6274 44 32 44H12C5.37258 44 0 38.6274 0 32V12Z",
    fill: "#F5F0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_13013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6916 13.8167C22.4744 13.7176 22.2385 13.6664 21.9999 13.6664C21.7612 13.6664 21.5254 13.7176 21.3082 13.8167L14.1666 17.0667C14.0187 17.1319 13.893 17.2387 13.8047 17.3741C13.7164 17.5094 13.6694 17.6676 13.6694 17.8292C13.6694 17.9908 13.7164 18.1489 13.8047 18.2843C13.893 18.4197 14.0187 18.5265 14.1666 18.5917L21.3166 21.85C21.5337 21.9491 21.7696 22.0003 22.0082 22.0003C22.2469 22.0003 22.4828 21.9491 22.6999 21.85L29.8499 18.6C29.9978 18.5348 30.1235 18.428 30.2118 18.2926C30.3 18.1573 30.347 17.9991 30.347 17.8375C30.347 17.6759 30.3 17.5178 30.2118 17.3824C30.1235 17.247 29.9978 17.1402 29.8499 17.075L22.6916 13.8167Z",
    stroke: "#7C3AED",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6665 22C13.6661 22.1594 13.7114 22.3155 13.7971 22.45C13.8828 22.5844 14.0052 22.6914 14.1498 22.7583L21.3165 26.0167C21.5325 26.1145 21.7669 26.1651 22.004 26.1651C22.2411 26.1651 22.4755 26.1145 22.6915 26.0167L29.8415 22.7667C29.989 22.7004 30.114 22.5926 30.2013 22.4564C30.2886 22.3203 30.3345 22.1617 30.3332 22",
    stroke: "#7C3AED",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6665 26.1666C13.6661 26.326 13.7114 26.4822 13.7971 26.6166C13.8828 26.751 14.0052 26.858 14.1498 26.925L21.3165 30.1833C21.5325 30.2811 21.7669 30.3317 22.004 30.3317C22.2411 30.3317 22.4755 30.2811 22.6915 30.1833L29.8415 26.9333C29.989 26.867 30.114 26.7592 30.2013 26.6231C30.2886 26.4869 30.3345 26.3283 30.3332 26.1666",
    stroke: "#7C3AED",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_13013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSites);
export default __webpack_public_path__ + "static/media/total_sites.8478e2717d9eb0198838e47b15b1924a.svg";
export { ForwardRef as ReactComponent };